module.exports = __webpack_public_path__ + "static/media/nvelope-bg.e2db74bd.png";